/**
 * Default pricing constants for the E-Freight Forwarding application
 * These values are used as fallbacks when database values are not available
 */

// Customs clearance pricing
export const CUSTOMS_CLEARANCE = {
  BASE_FEE: 45, // Base customs clearance fee in EUR
  INCLUDED_HS_CODES: 2, // Number of HS codes included in base price
  EXTRA_HS_CODE_FEE: 10, // Fee per additional HS code in EUR
  DISPLAY_FROM_STEP: 2, // Step at which to start showing customs clearance costs
};

// Handling fees
export const HANDLING = {
  BASE_FEE: 22.5, // Base handling fee in EUR
  DISPLAY_FROM_STEP: 4, // Step at which to start showing handling fees
};

// Delivery costs
export const DELIVERY = {
  MIN_FEE: 25, // Minimum delivery fee in EUR
  PER_CARTON_FEE: 2, // Fee per carton in EUR
  MAX_FEE: 150, // Maximum delivery fee in EUR
  DEFAULT_FEE: 65, // Default delivery fee when no tariff is found
  DISPLAY_FROM_STEP: 4, // Step at which to start showing delivery costs
};

// Air freight constants
export const AIR_FREIGHT = {
  VOLUMETRIC_FACTOR: 167, // CBM to kg conversion factor (1 CBM = 167 kg)
  DEFAULT_PRICE_PER_KG: 6.75, // Default price per kg in EUR
  DIESEL_SURCHARGE_RATE: 0.07, // 7% diesel surcharge
  DISPLAY_FROM_STEP: 4, // Step at which to start showing diesel surcharge
};

// Sea freight constants
export const SEA_FREIGHT = {
  DEFAULT_MIN_PRICE: 250, // Minimum price in EUR
  DEFAULT_PRICE_PER_KG: 4, // Default price per kg in EUR when no tariff is found
};

// Pickup fee constants (new optional fee)
export const PICKUP_FEE = {
  BASE_FEE: 75, // Base pickup fee in EUR
  DISPLAY_FROM_STEP: 0, // Always show pickup fee option
  APPLIES_TO_INCOTERM_IDS: [1], // List of incoterm IDs this applies to (1 = EXW)
};

// Export clearance fee constants
export const EXPORT_CLEARANCE = {
  BASE_FEE: 55, // Export clearance fee in EUR
  DISPLAY_FROM_STEP: 2, // Step at which to start showing export clearance
  EXCLUDED_INCOTERM_IDS: [3], // List of incoterm IDs where this doesn't apply (3 = FOB)
};

// Export clearance license fee constants
export const EXPORT_CLEARANCE_LICENSE = {
  BASE_FEE: 45, // Export clearance license fee in EUR
  DISPLAY_FROM_STEP: 0, // Always show the option
  EXCLUDED_INCOTERM_IDS: [3], // List of incoterm IDs where this doesn't apply (3 = FOB)
};

// Commodity inspection fee (fixed per booking when inspection is required)
export const COMMODITY_INSPECTION = {
  BASE_FEE: 75,
};

/**
 * Europallets: no fee when exchanged (geruild); otherwise €15 per pallet.
 * Applies in calculator (pallet mode) and invoice LMD when not exchanged.
 */
export const EUROPALLET = {
  FEE_PER_PALLET: 15,
  COST_TYPE: "europallet_non_exchange",
};

// Import duties note display configuration
export const IMPORT_DUTIES_NOTE = {
  DISPLAY_FROM_STEP: 2, // Step at which to show the import duties note
}; 